<!-- todo: Basic implementation without exposing props, need to refactor  -->
<template>
  <div class="secondary-header">
    <span class="ev-p-16 ev-font-light">
      <slot name="content" />
    </span>
    <nav class="header-section" aria-label="Main Navigation">
      <span class="eds-primary-nav-item">
        <slot name="mainNav" />
      </span>
    </nav>

    <nav class="header-section" aria-label="Utility Navigation">
      <span class="eds-primary-nav-item">
        <slot name="utilityNav" />
      </span>
    </nav>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'SecondaryHeader',
  });
</script>

<style>
  .secondary-header {
    --bg-opacity: 1;
    background-color: #ffffff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 400;
    font-family: Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
      'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    font-size: 24px;
    --text-opacity: 1;
    color: #333333;
    color: rgba(51, 51, 51, var(--text-opacity));
    height: 48px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .secondary-header .header-section {
    height: 100%;
    margin: 0;
    padding: 0;
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
</style>
